import { render } from "./GoodsListCate2.vue?vue&type=template&id=3073803b"
import script from "./GoodsListCate2.vue?vue&type=script&lang=js"
export * from "./GoodsListCate2.vue?vue&type=script&lang=js"

import "./GoodsListCate2.vue?vue&type=style&index=0&id=3073803b&lang=scss"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__